(function () {
    var MIN = 3.0;

    function parseRating(root) {
      var avgEl = root.querySelector('.bv_avgRating_component_container');
      var numEl = root.querySelector('.bv_numReviews_text, .bv_numReviews_component_container');
      var avg = avgEl ? parseFloat((avgEl.textContent || '').trim()) : NaN;
      var num = numEl ? parseInt(((numEl.textContent || '').match(/\d+/) || [0])[0], 10) : NaN;
      if (isNaN(avg) || isNaN(num)) {
        var m = (root.textContent || '').replace(/\s+/g, ' ').match(/(\d+(?:\.\d+)?)\s*\((\d+)\)/);
        if (m) {
          if (isNaN(avg)) avg = parseFloat(m[1]);
          if (isNaN(num)) num = parseInt(m[2], 10);
        }
      }
      if (isNaN(avg) && isNaN(num)) return null; // widget not rendered yet
      return { avg: isNaN(avg) ? 0 : avg, num: isNaN(num) ? 0 : num };
    }

    function mark(el, ok) {
      if (!el) return;
      el.classList.remove(ok ? 'gh-bv-hide' : 'gh-bv-ok');
      el.classList.add(ok ? 'gh-bv-ok' : 'gh-bv-hide');
      // Inline styles as well: BV stylesheets can otherwise win the cascade.
      if (ok) {
        if (el.style.display === 'none') el.style.removeProperty('display');
        el.style.removeProperty('visibility');
      } else {
        el.style.setProperty('display', 'none', 'important');
      }
    }

    function process() {
      // Product grid tiles: hide the whole inline rating
      document.querySelectorAll('[data-bv-show="inline_rating"]').forEach(function (el) {
        var r = parseRating(el);
        if (!r) return;
        mark(el, r.num > 0 && r.avg >= MIN);
      });

      // PDP rating summary: hide stars + score + count, keep "Write a review"
      document.querySelectorAll('[data-bv-show="rating_summary"]').forEach(function (el) {
        var r = parseRating(el);
        if (!r) return;
        var ok = r.num > 0 && r.avg >= MIN;
        var parts = el.querySelectorAll(
          '.bv_main_container_row_flex.bv_ratings_summary, .bv_stars_component_container, .bv_avgRating_component_container, .bv_numReviews_component_container'
        );
        parts.forEach(function (p) { mark(p, ok); });
      });
    }

    function start() {
      process();
      var mo = new MutationObserver(function () {
        window.clearTimeout(window.__ghBvTimer);
        window.__ghBvTimer = window.setTimeout(process, 60);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
      var ticks = 0;
      var iv = window.setInterval(function () {
        process();
        if (++ticks > 40) window.clearInterval(iv); // stop after ~20s
      }, 500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
